export default __webpack_public_path__ + "static/media/logoSurcapColor.55c39ec1.svg";